export class Civilite {

    id: string;
    libelle: string;
    personne_morale: boolean;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                 = data['id'] ? data['id'] : null;
        this.libelle            = data['libelle'] ? data['libelle'] : null;
        this.personne_morale    = data['personne_morale'] ? (data['personne_morale'] === '1') : false;
    }

}
